﻿import React, { PropsWithChildren } from "react";

interface ILegalPartialSubcontainerComponentProps {
    title: string;
}

interface ILegalPartialSubcontainerComponentState {
    active: boolean;
}

export class LegalPartialSubcontainerComponent extends React.Component<PropsWithChildren<ILegalPartialSubcontainerComponentProps>, ILegalPartialSubcontainerComponentState> {
    constructor(props: PropsWithChildren<ILegalPartialSubcontainerComponentProps>) {
        super(props);

        this.state = {
            active: false,
        };
    }

    toggleActive = (event): void => {
        this.setState(prevState => ({
            active: !prevState.active,
        }));
    };

    render() {
        const { active } = this.state;

        return (
            <div className={"legal-partial-subcontainer" + (active ? " active" : "")}>
                <h2 onClick={this.toggleActive}>{this.props.title}</h2>
                <div className={"content"}>{active && this.props.children}</div>
            </div>
        );
    }
}
